export default __webpack_public_path__ + "static/media/WB_Fynns.5dc83e9e.gif";